import { render, staticRenderFns } from "./establishEnclosure.vue?vue&type=template&id=455a8e5d&scoped=true"
import script from "./establishEnclosure.vue?vue&type=script&lang=js"
export * from "./establishEnclosure.vue?vue&type=script&lang=js"
import style0 from "./establishEnclosure.vue?vue&type=style&index=0&id=455a8e5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a8e5d",
  null
  
)

export default component.exports